<template>
  <img
    v-bind="$attrs"
    :src="currentSrc"
    :alt="alt"
    data-theme-aware="true"
    :data-theme-icon="iconConfigString"
  />
</template>

<script setup>
import { computed } from "vue";
import store from "@/src/store/index.js";
import { themeIconMap } from "@/src/utils/themeIconMap";
import { themeTypes } from "@/src/constants/themeConstants.js";

const props = defineProps({
  icon: {
    type: String,
    required: true,
    validator: (value) => {
      return !!themeIconMap[value];
    },
  },
  alt: {
    type: String,
    default: "",
  },
});

defineOptions({
  inheritAttrs: false,
  name: "ThemeImage",
});

const iconConfig = computed(() => themeIconMap[props.icon]);
const iconConfigString = computed(() => JSON.stringify(iconConfig.value));

const currentSrc = computed(() => {
  const theme = store.getters["theme/getEffectiveTheme"];
  return theme === themeTypes.LIGHT
    ? iconConfig?.value?.lightIcon
    : iconConfig?.value?.darkIcon;
});
</script>
